import { FC, useState, useEffect } from "react";
import { RadioGroup } from "@headlessui/react";
import { AddressType } from "data/types";

interface RadioProps {
  data: AddressType[];
  oneSelected: AddressType;
  handleSelect: (id: string) => void;
  className?: string;
}

const Radio: FC<RadioProps> = ({
  data = [],
  oneSelected,
  handleSelect = () => {},
  className = "",
}) => {
  const [selected, setSelected] = useState(oneSelected);
  
  useEffect(() => {
    handleSelect(selected?._id || "");
  }, [selected]);

  useEffect(() => {
    setSelected(oneSelected);
  }, [oneSelected]);

  return (
    <div className={`${className}`}>
      <div className="w-full">
        <RadioGroup value={selected} onChange={setSelected}>
          <RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
          <div className="space-y-2">
            {data.map((address) => (
              <RadioGroup.Option
                key={address._id}
                value={address}
                className={({ active, checked }) =>
                  `${
                    active
                      ? "ring-2 ring-offset-2 ring-offset-sky-300 ring-white ring-opacity-60"
                      : ""
                  }
                  ${checked ? "bg-primary-6000 text-white" : "bg-white"}
                    relative rounded-lg shadow-md px-5 py-4 cursor-pointer flex focus:outline-none`
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center">
                        <div className="text-sm">
                          <RadioGroup.Label
                            as="p"
                            className={`font-medium  ${
                              checked ? "text-white" : "text-gray-900"
                            }`}
                          >
                            {address.name}
                          </RadioGroup.Label>
                          <RadioGroup.Description
                            as="span"
                            className={`inline ${
                              checked ? "text-sky-100" : "text-gray-500"
                            }`}
                          >
                            <span>{address.kecamatan.name}</span>{" "}
                            <span aria-hidden="true">&middot;</span>{" "}
                            <span>{address.recipient}</span>
                          </RadioGroup.Description>
                        </div>
                      </div>
                      {checked && (
                        <div className="flex-shrink-0 text-white">
                          <CheckIcon className="w-6 h-6" />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default Radio;

function CheckIcon(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
      <path
        d="M7 13l3 3 7-7"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
